import type { Moment } from '@app/utils/moment'
import moment from '@app/utils/moment'
import { roundDate } from '@app/utils/timeHelper'

import { MIN_MINUTES_TO_START } from './constants'

export const generateTimeOptions = (date: Moment | null, now: Moment = moment()) => {
  const minDateTime = roundDate(now.clone()).add(MIN_MINUTES_TO_START, 'minutes')
  const minDate = minDateTime.clone().startOf('day')

  const minTime = date && date.isSameOrBefore(minDate, 'day') ? toMinutes(minDateTime.format('HH:mm')) : 0
  const correctDate = date?.isSameOrAfter(minDate, 'day') ? date : minDate

  return { date: correctDate, minDate, minTime }
}

const toMinutes = (input: string): number => {
  const [hours, minutes] = input.split(':').map(p => parseInt(p, 10))
  return hours * 60 + minutes
}
